import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpContextToken } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { ServerErrorDialogService } from "@core/components/ui/server-error-dialog/services/server-error-dialog.service";

export const SKIP_SERVER_ERROR_INTERCEPTOR: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  public constructor (private dialog: MatDialog, private _serverErrorDialogService: ServerErrorDialogService) {}

  intercept (req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status >= 500 && !req.context.get(SKIP_SERVER_ERROR_INTERCEPTOR)) this._serverErrorDialogService.showServerErrorDialog();


        return throwError(() => error);
      })
    );
  }
}
